import React, { Component } from 'react'
import { Flex, Bar, Text } from './styles'

class PasswordIndicator extends Component {
  render() {
    let array = [1, 2, 3, 4]
    const { passwordStrength } = this.props
    let color = ''
    let text = ''
    if (passwordStrength.strength === 1) {
      color = '#8F1004'
      text = 'Matig'
    } else if (passwordStrength.strength === 2) {
      color = '#C8790B'
      text = 'Oke'
    } else if (passwordStrength.strength === 3) {
      color = '#A5D373'
      text = 'Goed'
    } else if (passwordStrength.strength === 4) {
      color = '#6A8949'
      text = 'Zeer goed'
    }
    return (
      <Flex>
        {array.map((item, index) => {
          if (index < passwordStrength.strength) {
            return <Bar key={index} color={color} />
          } else {
            return <Bar key={index} />
          }
        })}
        <Text color={color}>{text}</Text>
      </Flex>
    )
  }
}

export default PasswordIndicator



// WEBPACK FOOTER //
// ./src/components/PasswordIndicator/index.js